import { render, staticRenderFns } from "./VoteSlide.vue?vue&type=template&id=8567dd0c"
import script from "./VoteSlide.vue?vue&type=script&lang=js"
export * from "./VoteSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports